import styled from "styled-components";
import { apolloFontFamilyBodySmall, apolloFontSizeBodySmall, apolloFontWeightBodySmall, apolloLineHeightBodySmall, apolloSpaceInset1X, apolloSpaceInset2X, apolloSpaceStack1X, } from "@nexthink/apollo-tokens";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
const tabBorder = 1;
const bottomLineTabGroupStroke = 1;
const bottomLineTabSelectedStroke = 2;
export const StyledTab = styled.div.withConfig({ displayName: "StyledTab_APC-7281-productShell", componentId: "sc-4ifoc4" })(({ theme, disabled, selected }) => ({
    // to avoid its style to be overridden when used with `as={Link}`
    "&&": Object.assign(Object.assign({ alignItems: "center", boxSizing: "border-box", color: theme.colors.apolloColorTextPrimary, cursor: disabled ? "not-allowed" : "pointer", display: "inline-flex", flexBasis: "auto", flexGrow: 0, flexShrink: 0, outline: "none", overflow: "visible", position: "relative", textAlign: "center", textDecoration: "none", "&:hover": {
            textDecoration: "none",
        } }, (disabled && {
        "& *": {
            color: theme.colors.apolloColorTextDisabled,
        },
    })), { "&[data-focus-visible-added]": {
            outline: "none",
            border: `1px solid ${theme.colors.apolloColorStrokeFocus}`,
        }, background: "transparent", border: `${tabBorder}px solid transparent`, font: `${apolloFontWeightBodySmall} ${apolloFontSizeBodySmall}/${apolloLineHeightBodySmall} ${apolloFontFamilyBodySmall}`, marginBottom: apolloSpaceStack1X, "&::after": {
            background: theme.colors.apolloColorStrokeSelected,
            bottom: `${-getValueFromPixelString(apolloSpaceStack1X) -
                tabBorder -
                bottomLineTabSelectedStroke +
                bottomLineTabGroupStroke}px`,
            content: '""',
            display: selected && !disabled ? "block" : "none",
            height: `${bottomLineTabSelectedStroke}px`,
            left: `${-tabBorder}px`,
            position: "absolute",
            right: `${-tabBorder}px`,
        } }),
}));
export const StyledTabContent = styled.div.withConfig({ displayName: "StyledTabContent_APC-7281-productShell", componentId: "sc-150pxax" })({
    outline: "none",
    display: "inline-flex",
    alignItems: "center",
    padding: `${getValueFromPixelString(apolloSpaceInset1X) - tabBorder}px ${getValueFromPixelString(apolloSpaceInset2X) - tabBorder}px`,
});
//# sourceMappingURL=Tab.style.js.map